import script from "./cadastrar-atividade.vue?vue&type=script&setup=true&lang=js"
export * from "./cadastrar-atividade.vue?vue&type=script&setup=true&lang=js"

import "./cadastrar-atividade.vue?vue&type=style&index=0&id=0281da1b&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0281da1b"]])

export default __exports__